module.exports = __webpack_public_path__ + "static/media/charge_logo.4b296435.png";